import { render, staticRenderFns } from "./GiveMarkWindow.vue?vue&type=template&id=430370f8&scoped=true&"
import script from "./GiveMarkWindow.vue?vue&type=script&lang=js&"
export * from "./GiveMarkWindow.vue?vue&type=script&lang=js&"
import style0 from "./GiveMarkWindow.vue?vue&type=style&index=0&id=430370f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "430370f8",
  null
  
)

export default component.exports